import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import {
    FormControlLabel, Checkbox, FormControl, Button,
    FormGroup, TextField, CircularProgress, makeStyles, Radio, RadioGroup, Divider
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';
import { dateFormatter } from '../Models/CommonFunc'
import classNames from 'classnames';
import { convertToRaw, EditorState, RichUtils, convertFromHTML, ContentState } from 'draft-js'
import { Editor } from 'react-draft-wysiwyg';
import { newEvent } from '../Models/ProductsModel';
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import CustomAlert from '../CustomAlert';
import mapValues from 'lodash/mapValues';
import draftToHtml from 'draftjs-to-html';
import { Helmet } from 'react-helmet';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars'
import { getHealthCampsDocumentWithUniqueId, updateHealthCampsDocument, uploadHealthCampsImageInBase64 } from '../../Backend/firebase/health-camps';
import { sleep, resizeEventFileImage } from '../Models/CommonFunc';
import { EntryFeeInputRow } from './EntryFeeInputRow';

const useStyles = makeStyles((theme) => ({
    root: {

        '& .MuiFormControlLabel-label.Mui-disabled': {
            color: 'white'
        }
    },
}));

function UpdateHealthCamps({ eventId, setOpenPopup, setIsPageReload }) {
    const classes = useStyles();
    const { register, handleSubmit, errors, reset, setValue } = useForm({
        defaultValues: {
            'Compostions.capsule': false,
            'Compostions.freelance': false
        }
    });
    const [eventDescription, setEventDescription] = useState(() => EditorState.createEmpty());
    const [aboutTheHealthCamp, setAboutTheHealthCamp] = useState(() => EditorState.createEmpty());
    const [eligibilityCriteria, setEligibilityCriteria] = useState(() => EditorState.createEmpty());
    const [sponsorshipDetails, setSponsorshipDetails] = useState(() => EditorState.createEmpty());
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [isStartDateModified, setIsStartDateModified] = useState(false);
    const [isEndDateModified, setIsEndDateModified] = useState(false);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();
    const [isEventEditable, setIsEventEditable] = useState(true);
    const [eventStatusUpdated, setEventStatusUpdated] = useState('');
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isEntryFree, setIsEntryFree] = useState('Free');
    const [entryFeeFields, setEntryFeeFields] = useState([
        {
            uniqueId: "",
            entryCategory: "",
            entryFees: "",
        }
    ]);


    useEffect(async () => {
        try {
            const getEvents = await getHealthCampsDocumentWithUniqueId(eventId);
            setTimeout(() => {
                mapValues(getEvents[0], (value, key) => {
                    if(key != "startDate" && key != "endDate") {
                        setValue(key, value)
                    }
                });
            });
            setEventStatusUpdated(getEvents[0].eventStatus);
            setStartDate(getEvents[0].startDate.toDate());
            setEndDate(getEvents[0].endDate.toDate());
            setEventDescription(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(draftToHtml(JSON.parse(getEvents[0].eventDescription))))))
            setAboutTheHealthCamp(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(draftToHtml(JSON.parse(getEvents[0].aboutTheHealthCamp))))))
            setEligibilityCriteria(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(draftToHtml(JSON.parse(getEvents[0].eligibilityCriteria))))))
            setSponsorshipDetails(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(draftToHtml(JSON.parse(getEvents[0].sponsorshipDetails))))))
            setIsEntryFree(getEvents[0]?.isEntryFree ? getEvents[0]?.isEntryFree : 'Free')
            setEntryFeeFields([...(getEvents[0].entryFeeFields)])
        } catch(error) {
            console.log("Error Occur in Update Event", error)
        }
    }, []);

    const handleEventStatusUpdatedChange = (event) => {
        setEventStatusUpdated(event.target.value);
    };

    const onSubmit = async (data) => {
        setIsLoading(true);
        const eventDescriptionValue = convertToRaw(eventDescription.getCurrentContent());
        const aboutTheHealthCampValue = convertToRaw(aboutTheHealthCamp.getCurrentContent());
        const eligibilityCriteriaValue = convertToRaw(eligibilityCriteria.getCurrentContent());
        const sponsorshipDetailsValue = convertToRaw(sponsorshipDetails.getCurrentContent());
        // if (eventDescription.getCurrentContent().hasText()) {
            newEvent.uniqueId = eventId;
            newEvent.userId = userData.uid;
            newEvent.eventName = data.eventName;
            newEvent.eventType = data.eventType;
            newEvent.modeOfEvent = data.modeOfEvent;
            newEvent.eventCategory = "Health Camps";
            newEvent.location = data.location;
            newEvent.organizer = data.organizer;
            newEvent.phone = data.phone;
            if(isStartDateModified) {
                newEvent.startDate = startDate;
            }
            if(isEndDateModified) {
                newEvent.endDate = endDate;
            }
            newEvent.eventSubmissionURL = data.eventSubmissionURL;
            if (data.eventImageDocument.length > 0) {
                var newFileImage = await resizeEventFileImage(data.eventImageDocument[0]);
                const ref = await uploadHealthCampsImageInBase64(eventId,
                    newFileImage.substring(22),
                    updateProgress);
                const downloadUrl = await ref.getDownloadURL();
                newEvent.eventImage = downloadUrl
            }
            newEvent.eventStatus = data.eventStatus;
            newEvent.eventDescription = String(JSON.stringify(eventDescriptionValue));
            newEvent.aboutTheHealthCamp = String(JSON.stringify(aboutTheHealthCampValue));
            newEvent.eligibilityCriteria = String(JSON.stringify(eligibilityCriteriaValue));
            newEvent.sponsorshipDetails = String(JSON.stringify(sponsorshipDetailsValue));
            newEvent.isEntryFree = isEntryFree;
            newEvent.entryFeeFields = entryFeeFields;
            try {
                var event = updateHealthCampsDocument(newEvent);
                if (event) {
                    setOpenPopup(false);
                    setNotificationMessage('Event Updated successfully.');
                    setOpenNotify(true);
                    setAlertType('success');
                    setIsLoading(false);
                    setIsPageReload(true)
                    setTimeout(routeToPages, 2000);
                } else {
                    setNotificationMessage('Something went wrong, Please try again later!!');
                    setOpenNotify(true);
                    setAlertType('error');
                    setIsLoading(false);
                    history.push('/retailer/create-health-camps');
                }
            }  catch (error) {
                console.error(error);
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/create-health-camps');
            }
        // } else {
        //     setNotificationMessage("Please enter event description!");
        //     setOpenNotify(true);
        //     setAlertType('error');
        //     setIsLoading(false);
        // }
    };

    const routeToPages = () => {
        history.push('/retailer/health-camps');
    }

    const onEditorStateChange = (editorState) => {
        setEventDescription(editorState);
    };

    const onEditorAboutTheHealthCampStateChange = (editorState) => {
        setAboutTheHealthCamp(editorState);
    };

    const onEditorEligibilityCriteriaStateChange = (editorState) => {
        setEligibilityCriteria(editorState);
    };

    const onEditorSponsorshipDetailsStateChange = (editorState) => {
        setSponsorshipDetails(editorState);
    };

    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        setIsStartDateModified(true);
    }

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
        setIsEndDateModified(true);
    }

    const updateProgress = (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setUploadProgress(progress);
    }

    const handleIsEntryFreeChange = (event) => {
        setIsEntryFree(event.target.value);
    };

    const handleEntryFeesAdd = () => {
        setEntryFeeFields([
            ...entryFeeFields,
            {
                uniqueId: "",
                entryCategory: "",
                entryFees: "",
            }
        ])
    }
    const handleEntryFeesRemove = (index) => {
        if (entryFeeFields.length !== 1) {
            const values = [...entryFeeFields]
            values.splice(index, 1)
            setEntryFeeFields(values)
        }
    }
    const handleEntryFeesChange = (event, index) => {
        const uniqueId = uuidv4();
        const values = [...entryFeeFields]
        values[index][event.target.name] = event.target.value
        values[index]["uniqueId"] = uniqueId

        setEntryFeeFields(values)
    }

    return (
        <>
            <div className={classes.root}>
                <Helmet>
                    <meta name="description" content="Use this page to update event." />
                    <title>Update Event | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="updateProduct">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            <div className="col-md-2 mb-2 createProduct__labelValign">
                                Event Status <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                            </div>
                            <div className="col-md-10 mb-2">
                                <FormControl component="fieldset">
                                    <RadioGroup aria-label="eventStatus" name="eventStatus" row>
                                        <FormControlLabel value="New" control={<Radio checked={eventStatusUpdated === 'New'}
                                            onChange={handleEventStatusUpdatedChange}
                                            value="New"
                                            className="skilsForm__radioBtn" />}
                                            label="New"
                                            name="eventStatus"
                                            inputRef={register}
                                            className="updateProduct__hoursPerWeek" />
                                        <FormControlLabel value="Expired" control={<Radio checked={eventStatusUpdated === 'Expired'}
                                            onChange={handleEventStatusUpdatedChange}
                                            value="Expired"
                                            className="skilsForm__radioBtn" />}
                                            label="Expired"
                                            name="eventStatus"
                                            inputRef={register}
                                            className="updateProduct__hoursPerWeek" />
                                    </RadioGroup>
                                </FormControl>
                            </div>
                            <div className="col-md-8 mb-2">
                                Name of the Health Camp <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.eventName })}
                                    name="eventName" autoComplete="none"
                                    ref={register({ required: 'Please enter Name of the Health Camp!' })} />
                                <small className="form-text text-danger">{errors.eventName && errors.eventName.message}</small>
                            </div>
                            <div className="col-md-4 mb-2">
                                Event Image 
                                <input
                                    type="file"
                                    className={classNames('form-control registerEmp__textbox')}
                                    name="eventImageDocument"
                                    placeholder="Franchise Image"
                                    accept=".png,.jpg,.jpeg"
                                    ref={register}
                                    onChange={(e)=> {  }}
                                />
                            </div>
                            <div className="col-md-6 mb-2">
                                Name of the Organizer <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.organizer })}
                                    name="organizer" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter Name of the Organizer!' })} />
                                <small className="form-text text-danger">{errors.organizer && errors.organizer.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Contact Number of Organizer <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.phone })}
                                    name="phone" autoComplete="none"
                                    ref={register({ required: 'Please enter Contact Number of Organizer!' })} />
                                <small className="form-text text-danger">{errors.phone && errors.phone.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Start Date <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <DatePickerComponent
                                    id="startDate"
                                    name="startDate"
                                    value={startDate}
                                    cssclassName="e-outline"
                                    onChange={(e) => handleStartDateChange(e)}
                                    ref={register({ required: 'Please enter Start Date!' })}
                                />
                                <small className="form-text text-danger">{errors.startDate && errors.startDate.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                End Date <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <DatePickerComponent
                                    id="endDate"
                                    name="endDate"
                                    value={endDate}
                                    cssclassName="e-outline"
                                    onChange={(e) => handleEndDateChange(e)}
                                    ref={register({ required: 'Please enter End Date!' })}
                                />
                                <small className="form-text text-danger">{errors.endDate && errors.endDate.message}</small>
                            </div>
                            <div className="col-md-12 mb-2">
                                Location <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.location })}
                                    name="location" autoComplete="none"
                                    ref={register({ required: 'Please enter Location!' })} />
                                <small className="form-text text-danger">{errors.location && errors.location.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Type of Event <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.eventType })}
                                    name="eventType" 
                                    autoComplete="none"
                                    ref={register({ required: 'Please enter event Type!' })} />
                            </div>
                            <div className="col-md-6 mb-2">
                                Mode of Event <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.modeOfEvent })} aria-label="Default select example"
                                    name="modeOfEvent" ref={register({
                                        required: 'Please select Mode of Events!',
                                        validate: {
                                            defaultValue: value => value !== "Select Mode Of Event" || 'Please select mode of Event!'
                                        }
                                    })} defaultValue="Select Event Type">
                                    <option value="Online">Online</option>
                                    <option value="Offline">Offline</option>
                                </select>
                            </div>
                            <div className="col-md-12 mb-2">
                                Event Submission URL <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.eventSubmissionURL })}
                                    name="eventSubmissionURL"
                                    autoComplete="none"
                                    placeholder="Event Google Form URL"
                                    ref={register({ required: 'Please enter Event Submission URL (Google Form)!' })}
                                />
                                <small className="form-text text-danger">{errors.eventSubmissionURL && errors.eventSubmissionURL.message}</small>
                            </div>
                            <h3 className="mt-4">Descriptions</h3>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>About the Health Camp</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={aboutTheHealthCamp} onEditorStateChange={onEditorAboutTheHealthCampStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Eligibility Criteria</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={eligibilityCriteria} onEditorStateChange={onEditorEligibilityCriteriaStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Sponsorship Details</b> <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={sponsorshipDetails} onEditorStateChange={onEditorSponsorshipDetailsStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <div className="col-md-12 mb-2 mr-3">
                                <b>Other Details</b>
                                <div className="createProduct__RictTextEditor">
                                    <Editor editorState={eventDescription} onEditorStateChange={onEditorStateChange}
                                        className="createProduct__editorCss"
                                        toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName"
                                        editorClassName="editorClassName" />
                                </div>
                            </div>
                            <h4 className="mt-4 border__bottom">Entry Fees</h4>
                            <div className="col-md-12 mb-2 mr-3">
                                <div className="col-md-10 mb-2">
                                    <FormControl component="fieldset">
                                        <RadioGroup aria-label="isEntryFree" name="isEntryFree" row>
                                            <FormControlLabel value="Free" control={<Radio checked={isEntryFree === 'Free'}
                                                onChange={handleIsEntryFreeChange}
                                                value="Free"
                                                className="skilsForm__radioBtn" />}
                                                label="Free"
                                                name="isEntryFree"
                                                inputRef={register}
                                                className="updateProduct__hoursPerWeek" />
                                            <FormControlLabel value="Entry Fees reqiured" control={<Radio checked={isEntryFree === 'Entry Fees reqiured'}
                                                onChange={handleIsEntryFreeChange}
                                                value="Entry Fees reqiured"
                                                className="skilsForm__radioBtn" />}
                                                label="Entry Fees reqiured"
                                                name="isEntryFree"
                                                inputRef={register}
                                                className="updateProduct__hoursPerWeek" />
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                                <div className="col-md-2 mb-2"></div>
                            </div>
                            <div className="row mb-3">
                                {entryFeeFields.map((item, index) => (
                                    <>
                                        <div key={index}>
                                            <EntryFeeInputRow
                                                errors={errors}
                                                register={register}
                                                inputFields={entryFeeFields}
                                                index={index}
                                                item={item}
                                                handleForm={entryFeeFields[index]}
                                                handleChange={handleEntryFeesChange}
                                                handleRemove={handleEntryFeesRemove}
                                                handleAdd={handleEntryFeesAdd}
                                            />
                                        </div>
                                        <Divider />
                                    </>
                                ))}
                            </div>
                            <div className="col-md-12 mb-3 w-100">
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <div className="p-2">
                                        {/* <Button variant="contained" onClick={() => setIsEventEditable(false)}
                                            style={{ marginRight: '10px' }}>
                                            Edit Event
                                        </Button> */}
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Update Event'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default UpdateHealthCamps
